module.exports = __webpack_public_path__ + "img/plus_btn.38d5d3d9.png";